import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { Money } from '../../Money';
import WarningModal from '../../WarningModal';
import { useTheme } from '../../theme';
import MediaQuery from '../../MediaQuery/MediaQuery';
import Tooltip from '@mui/material/Tooltip';
import { ArrowForward } from '../../Icons';
import ModalConfirm from '../../ModalConfirm';
import { BaseButton, IconButton } from '../../BaseComponents';
import { useElementHeightCSSVar } from '../../hooks';
let lastErrorMessage = '';
const Toolbar = ({ totalPrice, onBackButtonClick, onButtonClick, additional, buttonDisabled, actionsRight, isLoading, error, hideNextButton, onCloseErrorMsg, miles, className, nextButtonClassName, priceInMiles, innerClassName, onRetrySearch, nextButtonText }) => {
    const { Toolbar: css } = useTheme('Toolbar');
    const { t } = useTranslation('Toolbar');
    const { ref, initialHeight } = useElementHeightCSSVar('toolbar-height');
    // This prevents error message blinking.
    if (error && error.message) {
        lastErrorMessage = error.message;
    }
    const retryErrorMessages = ['No appropriate flights found on the segment'];
    const retryMessage = retryErrorMessages.find(it => { var _a; return (_a = error === null || error === void 0 ? void 0 : error.message) === null || _a === void 0 ? void 0 : _a.includes(it); });
    return (React.createElement("div", { className: cn(css.toolbar, className, 'mui-fixed', { [css.toolbar_tall]: initialHeight > 400 }), id: "toolbar", ref: ref },
        React.createElement(WarningModal, { title: t('Oops...'), content: t('An unexpected error has occurred during the creating order process. Please try again later or contact a customer support service.'), isOpen: !!error && !retryMessage, onButtonClick: onCloseErrorMsg, errorMessage: lastErrorMessage, onClose: onCloseErrorMsg, buttonText: t('OK, thank you') }),
        React.createElement(ModalConfirm, { title: t('Error...'), isOpen: !!error && !!retryMessage, onConfirm: () => {
                onCloseErrorMsg();
                onRetrySearch();
            }, onClose: onCloseErrorMsg, onCancel: onCloseErrorMsg, confirmBtn: t('Try again') },
            React.createElement("div", null, t(retryMessage))),
        React.createElement("div", { className: cn(css.inner, innerClassName) },
            React.createElement("div", { className: cn(css.actions, css.actions_left) },
                !!onBackButtonClick && (React.createElement("div", { className: css.backButton__wrapper, onClick: onBackButtonClick },
                    React.createElement(IconButton, { className: css.backButton }, ArrowForward),
                    React.createElement("span", { className: css.backButton__text }, t('Back')))),
                additional),
            React.createElement("div", { className: cn(css.actions, { [css.actions_right]: actionsRight }) },
                totalPrice && !!totalPrice.amount && (React.createElement("span", { className: css.price },
                    React.createElement(MediaQuery, { minWidth: "mobile" },
                        t('Total'),
                        ": ",
                        React.createElement(Money, { money: totalPrice }),
                        (miles > 0 || priceInMiles > 0) && (React.createElement("div", { className: css.miles },
                            React.createElement(Money, { money: {
                                    amount: priceInMiles > 0 ? priceInMiles : miles,
                                    currency: 'miles'
                                }, showCurrency: false, moneyClassName: css.miles__money }),
                            t(priceInMiles > 0 ? 'miles will be charged' : 'miles will be awared'),
                            React.createElement(Tooltip, { title: t(priceInMiles > 0
                                    ? 'This flight will be partially paid by miles'
                                    : 'Fly with us and get miles') },
                                React.createElement("div", { className: css.miles__hint }))))))),
                !hideNextButton && (React.createElement(BaseButton, { className: cn(css.button, nextButtonClassName, { [css.button_disabled]: buttonDisabled }), onClick: e => {
                        onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick(e);
                    }, variant: "smallPrimary", isLoading: isLoading, disabled: buttonDisabled, type: onButtonClick ? 'button' : 'submit', "data-next-button": true }, nextButtonText !== null && nextButtonText !== void 0 ? nextButtonText : t('Continue')))))));
};
export default Toolbar;
